import { render } from "./Tradeoffer.vue?vue&type=template&id=1131252e&scoped=true"
import script from "./Tradeoffer.vue?vue&type=script&lang=js"
export * from "./Tradeoffer.vue?vue&type=script&lang=js"

import "./Tradeoffer.vue?vue&type=style&index=0&id=1131252e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1131252e"]])

export default __exports__